<!--
 * @Author: Lemon C
 * @Date: 2024-05-14 17:16:53
 * @LastEditTime: 2024-12-05 11:26:43
-->
<template>
    <div class="sup-msg-type-comp">
        <div :class="`msg-item-box ${item_sel_type === 0 ? 'isActive' : ''}`" @click="item_type_click(0)">
            <div class="item-icon-all">
                <el-icon><HelpFilled /></el-icon>
            </div>
            <span class="item-title">全部消息</span>
            <div class="item-num-box">{{ msg_all_num }}</div>
        </div>
        <div :class="`msg-item-box ${item_sel_type === 2 ? 'isActive' : ''}`" @click="item_type_click(2)">
            <div class="item-icon-unread">
                <el-icon><Comment /></el-icon>
            </div>
            <span class="item-title">未读消息</span>
            <div class="item-num-box">{{ msg_unread_num }}</div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted } from 'vue';

import { getMessageNum } from '@/service/interface';

const props = defineProps({
    msg_type_callback: Function,
});

const service_promise_list = ref([]); // 请求列表
const msg_all_num = ref(0); // 全部消息数量
const msg_unread_num = ref(0); // 未读消息数量
const item_sel_type = ref(0); // 0: 全部 2: 未读

onMounted(() => {
    update_data();
});

const update_data = () => {
    service_get_msg_num();
};

// MARK  获取消息数量
const service_get_msg_num = () => {
    // 重新生成 promise 列表
    service_promise_list.value = [
        { type: 0, promise: getMessageNum({ params: { type: 0 } }) },
        { type: 2, promise: getMessageNum({ params: { type: 2 } }) },
    ];
    let promiseArray = service_promise_list.value.map((e) => e.promise);
    Promise.all(promiseArray).then((response) => {
        response.forEach((res, index) => {
            let promise_obj = service_promise_list.value[index];
            if (res.isSuccess && promise_obj.type === 0) {
                msg_all_num.value = res.data;
            }
            if (res.isSuccess && promise_obj.type === 2) {
                msg_unread_num.value = res.data;
            }
        });
    });
};

// MARK Click  类型点击
const item_type_click = (type) => {
    item_sel_type.value = type;
    props.msg_type_callback(type);
};

// 方法暴露给父组件
defineExpose({
    update_data,
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-msg-type-comp {
    position: relative;
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--color-main-doc-segmentation-line-bg);
    padding: 10px 20px 10px 48px;

    .msg-item-box {
        position: relative;
        margin-top: 10px;
        display: flex;
        align-items: center;
        width: 100%;
        height: 48px;
        cursor: pointer;

        .item-icon-unread,
        .item-icon-all {
            position: relative;
            margin-left: 16px;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            flex-shrink: 0;
        }

        .item-icon-all {
            background: linear-gradient(180deg, #d2defd 0%, #d2defd 100%);

            i {
                font-size: 15px;
                color: var(--color-main-brand);
            }
        }

        .item-icon-unread {
            background: linear-gradient(180deg, #daffea 0%, #d9ffea 100%);

            i {
                font-size: 15px;
                color: var(--color-main-msg-green-bg);
            }
        }

        .item-title {
            position: relative;
            margin-left: 12px;
            font-weight: 400;
            font-size: 16px;
            color: var(--color-main-text-primary);
            line-height: 24px;
            display: flex;
            flex: 1;
        }

        .item-num-box {
            position: relative;
            margin-right: 16px;
            flex-shrink: 0;
            width: 36px;
            height: 22px;
            background: var(--color-main-brand-hover-light);
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: var(--color-main-brand);
            line-height: 20px;
        }

        &:hover {
            background: var(--color-main-brand-hover-light);
            border-radius: 4px;
        }

        &.isActive {
            background: var(--color-main-brand-hover-light);
            border-radius: 4px;

            .item-title {
                color: var(--color-main-brand);
            }

            .item-num-box {
                color: var(--color-main-text-brand-bg-primary);
                background: var(--color-main-brand);
            }
        }
    }
}
</style>
